import { memo, useEffect, useMemo, useState } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ImagesViewer from 'react-images-viewer';

// The viewer portals into <body> at z-index 2001, but react-native-web hosts
// every RN `Modal` (BottomPanel, sheets) in a body-level layer at 9999, so a
// preview opened from inside a modal would render behind it.
const kViewerTheme = { container: { zIndex: 10000 } };

export const ImageViewer = memo(
  (props: {
    images: string[];
    index?: number;
    show: boolean;
    shareButton?: boolean;
    onDismiss: () => void;
  }) => {
    const data = useMemo(
      () => props.images.map(uri => ({ src: uri })),
      [props.images],
    );

    const [currImg, setCurrImg] = useState(props.index ?? 0);

    useEffect(() => {
      setCurrImg(props.index ?? 0);
    }, [props.index]);

    return (
      <ImagesViewer
        backdropCloseable={true}
        theme={kViewerTheme}
        imgs={data}
        currImg={currImg}
        isOpen={props.show}
        onClickPrev={() => setCurrImg(currImg - 1)}
        onClickNext={() => setCurrImg(currImg + 1)}
        onClickThumbnail={(index: any) => setCurrImg(index)}
        showThumbnails={true}
        onClose={props.onDismiss}
      />
    );
  },
);
